"use client";

import { cn } from "../../lib/cn";
import { useTranslate } from "../../lib/translation";

import styles from "./SkipLink.module.css";

export interface SkipLinkProps {
  /**
   * Target fragment for the main content region. Defaults to "#main-content".
   * @default "#main-content" 
   */
  href?: string;
  /** Visible link text on focus. Defaults to the translated "Skip to main content" (`skipToMainContent`). */
  children?: React.ReactNode;
  /** Optional utility classes on the link. */
  className?: string;
}

/**
 * SkipLink component.
 *
 * Visually hidden until focused, then surfaces as a high-contrast pill so
 * keyboard users can jump straight to the main content.
 */
export function SkipLink({
  href = "#main-content",
  children,
  className,
}: SkipLinkProps) {
  const t = useTranslate();
  return (
    <a href={href} className={cn(styles.skipLink, className)}>
      {children ?? t("skipToMainContent", "Skip to main content")}
    </a>
  );
}
